module.exports = __webpack_public_path__ + "img/our1.af63c8e9.svg";